// extracted by mini-css-extract-plugin
module.exports = {"spinner":"AppLoader_spinner__35X0a","doubleBounce1":"AppLoader_doubleBounce1__3A4Bu","doubleBounce2":"AppLoader_doubleBounce2__2xCc_","sk-bounce":"AppLoader_sk-bounce___sL_f"};